/* Native contact disclosure; retain the theme's account panel and navigation. */
(function () {
  'use strict';
  if (window.piexHeaderControlsInitialized) return;
  window.piexHeaderControlsInitialized = true;
  var contactInvoker = null;
  function syncContact() {
    document.querySelectorAll('[data-piex-contact-toggle]').forEach(function (button) {
      var panel = document.getElementById(button.getAttribute('aria-controls'));
      button.setAttribute('aria-expanded', String(Boolean(panel && panel.closest('details').open)));
    });
  }
  // Panel alto: cabe en pantallas pequeñas o poco altas con desplazamiento interno y sin salirse por la derecha.
  function fitContact(details) {
    var panel = details.querySelector('.header-phone-number__desktop_submenu');
    var list = panel && panel.querySelector('.header-phone-number__desktop_submenu__container');
    if (!list) return;
    var gap = 12;
    var box = details.getBoundingClientRect();
    panel.style.left = '';
    var overflow = box.left + panel.offsetWidth - (window.innerWidth - gap);
    if (overflow > 0) panel.style.left = -Math.min(overflow, Math.max(box.left - gap, 0)) + 'px';
    var styles = getComputedStyle(panel);
    var top = box.bottom + (parseFloat(styles.getPropertyValue('--top-offset')) || 14);
    var padding = parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom);
    list.style.maxHeight = Math.max(window.innerHeight - top - padding - gap, 120) + 'px';
  }
  document.addEventListener('toggle', function (event) {
    if (!event.target.matches('.piex-header-contact')) return;
    if (event.target.open) fitContact(event.target);
    syncContact();
  }, true);
  window.addEventListener('resize', function () {
    document.querySelectorAll('.piex-header-contact[open]').forEach(fitContact);
  });
  function closeContact(details, returnFocus) {
    details.open = false;
    if (returnFocus) (contactInvoker || details.querySelector('summary')).focus();
    syncContact();
  }
  document.addEventListener('click', function (event) {
    var serviceContact = event.target.closest('[data-piex-contact-toggle]');
    if (serviceContact) {
      var panel = document.getElementById(serviceContact.getAttribute('aria-controls'));
      var contact = panel && panel.closest('.piex-header-contact');
      if (contact) {
        event.preventDefault();
        contactInvoker = serviceContact;
        contact.open = !contact.open;
        syncContact();
        if (contact.open) {
          var firstLink = panel.querySelector('a');
          if (firstLink) firstLink.focus({ preventScroll: true });
        }
        return;
      }
    }
    if (event.target.closest('.piex-contact-trigger')) contactInvoker = null;
    // «Cómo llegar» del panel abre la ventana de ubicación existente: se cierra el panel y, al cerrar la ventana, el foco vuelve a quien abrió Contacto.
    var helpInContact = event.target.closest('.piex-header-contact [data-piex-help]');
    if (helpInContact && document.querySelector('dialog[data-piex-help-dialog]')) {
      var owner = helpInContact.closest('.piex-header-contact');
      var returnTo = contactInvoker || owner.querySelector('summary');
      closeContact(owner, false);
      document.addEventListener('close', function back(closeEvent) {
        if (!closeEvent.target.matches || !closeEvent.target.matches('dialog[data-piex-help-dialog]')) return;
        document.removeEventListener('close', back, true);
        setTimeout(function () { if (returnTo.isConnected) returnTo.focus({ preventScroll: true }); }, 0);
      }, true);
    }
    var footerLink = event.target.closest('[data-piex-footer-link]');
    if (footerLink) {
      var target = document.getElementById(footerLink.dataset.piexFooterLink);
      if (target) {
        event.preventDefault();
        if (target.tagName === 'DETAILS') target.open = true;
        target.scrollIntoView({ block: 'start' });
        (target.querySelector('summary, input:not([type="hidden"])') || target).focus({ preventScroll: true });
      }
    }
    document.querySelectorAll('.piex-header-contact[open]').forEach(function (details) {
      if (!details.contains(event.target)) closeContact(details, false);
    });
    var toggle = event.target.closest('[data-piex-account-toggle]');
    document.querySelectorAll('[data-piex-account-toggle]').forEach(function (button) {
      if (button === toggle) button.setAttribute('aria-expanded', String(button.getAttribute('aria-expanded') !== 'true'));
      else if (!button.closest('.header-customer-accounts').contains(event.target)) button.setAttribute('aria-expanded', 'false');
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.piex-header-contact[open]').forEach(function (details) {
      closeContact(details, details.contains(document.activeElement) || document.activeElement === contactInvoker);
    });
    document.querySelectorAll('[data-piex-account-toggle][aria-expanded="true"]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
      button.focus();
    });
  });
}());
